import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function AnnouncementsList() {
    const [announcements, setAnnouncements] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get("/api/announcements")
            .then(res => {
                const sorted = (res.data || []).sort((a, b) => {
                    const getDateTime = (obj) => {
                        const time = obj.time || "00:00";
                        return new Date(`${obj.date}T${time}`);
                    };
                    return getDateTime(b) - getDateTime(a); // Newest first
                });
                setAnnouncements(sorted);
            })
            .catch(() => {
                console.error("Failed to load announcements");
            })
            .finally(() => setLoading(false));
    }, []);

    function formatDateTime(dateStr, timeStr = "00:00") {
        if (!dateStr) return "";

        const iso = `${dateStr}T${timeStr}`;
        const d = new Date(iso);

        return d.toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        });
    }

    if (loading || announcements.length === 0) return null;

    const visible = showAll ? announcements : announcements.slice(0, 1);

    return (
        <div className="mb-4">
            <h2>Announcements</h2>
            <ul className="list-group">
                {visible.map((a) => (
                    <li key={a._id} className="list-group-item">
                        <strong>{a.title}</strong>
                        <br />
                        <small className="text-muted">
                            {formatDateTime(a.date, a.time)}
                        </small>
                        <p className="mb-1">{a.content}</p>
                        {a.link && (
                            <Link className="small-link" to={`/members/` + a.link}>
                                Read More →
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
            {announcements.length > 1 && (
                <button className="btn small-link mt-2" onClick={() => setShowAll(!showAll)}>
                    {showAll ? "Show Less ↑" : "Show More ↓"}
                </button>
            )}
        </div>
    );
}
